// API base URL configuration.
//
// Production (npm run build): defaults to "/api" — the PHP API is deployed
// on the same domain as the React build (public_html/.../api/), so relative
// paths avoid any CORS setup.
//
// Local development: react-scripts serves the app on its own port and there
// is no bundled PHP server, so point REACT_APP_API_URL at wherever you're
// running the API locally, e.g. in ssmil/.env.development:
//   REACT_APP_API_URL=http://localhost:8000/api
// then from the ssmil/ folder run:  php -S localhost:8000 -t public
export const API_BASE_URL = process.env.REACT_APP_API_URL || '/api';

export function apiUrl(path) {
  return `${API_BASE_URL}${path}`;
}
